import React, { useEffect } from 'react';

// Inputs
import { TextInputField, DropDownField, MultiSelectField } from '../../../../helpers'

// Utils
import { getPIVerificationStatusHTML, getUOMStr, round } from '../../../../utils';

import { DECIMAL_LIMIT } from '../../../../constants';

import "../index.css"
import { getPMCompanyConfig } from '../../../../setup/pmCompanyConfig';
import Tooltip from '../../../../helpers/Tooltip';


const DispatchSellerPOItems = (props) => {
    const { buyerReqItemId, groupingItemId, sellerPO, sellerPOItem, displayLabel, isQtyCannotBeChanged, buyerCompany } = props

    const pmCompanyConfig = getPMCompanyConfig(sellerPO.pmCompanyId)

    let gstRates = pmCompanyConfig.GSTRates
    let gstOptions = []
    gstRates.map(eachGSTRate => gstOptions.push({label: eachGSTRate.toString(), GSTRate: eachGSTRate}))
    
    useEffect(() => {

    }, [])

    const piPunchItemTemplate = (option) => {
        const piVerificationStatus = getPIVerificationStatusHTML(option)
        return (
            <div className='flex'>
                <span className='mr-1'><strong>PI No: {option.sellerPINumber}</strong> | PI Date: {option.sellerPIDate} | PI Qty: {option.qty} | Avl Qty: {option.availablePIPunchQty}</span>
                {piVerificationStatus}
            </div>
        )
    }

    let labelName = ""
    if(displayLabel){
        if(isQtyCannotBeChanged){
            labelName = "Stock Qty"
        }else{
            labelName = "Disp. Qty"
        }
    }

    let UOMStr = getUOMStr(sellerPOItem.UOM, sellerPOItem.UOMValue)

    let dispatchingQty = isQtyCannotBeChanged ? sellerPOItem.availableDispatchQuantity : sellerPOItem.dispatchQty
    let invoicingQty = round(dispatchingQty * sellerPOItem?.companyQtyMultiplier)

    let relatedGSTRates = gstOptions.filter(eachGSTRate => sellerPOItem.GSTRate === eachGSTRate.GSTRate || sellerPOItem.bPOGSTRate === eachGSTRate.GSTRate)
    relatedGSTRates = relatedGSTRates.filter(eachGSTRate => sellerPOItem.GSTRate <= eachGSTRate.GSTRate)

    const isHSNEntryAllowed = pmCompanyConfig.HSNEntryAllowed

    let buyerCompanySellerPISkipped = buyerCompany?.tags?.canSkipPIVerification
    console.log("buyerCompanySellerPISkipped", buyerCompanySellerPISkipped, buyerCompany)

    const isPIPunchAllowed = (piPunch) => {
        return (piPunch.verifiedBy || piPunch.skippedBy || buyerCompanySellerPISkipped) && piPunch.availablePIPunchQty > 0
    }

    return (
        <div key={`sellerPOItem-${sellerPOItem.sellerPOItemId}`} className="md:grid md:align-items-center">
            <div className="flex flex-column md:flex-wrap col-12 md:col-12 lg:col-12 pl-0 pb-0">
                <div className="grid dispatch-seller-po-items">
                    <div className="flex flex-column col-12 md:col-6 lg:col-6 md:w-9rem pr-0">
                        <TextInputField name="SellerPONo" labelText={displayLabel && "SellerPO No"} value={sellerPOItem.docNo} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-6 lg:col-6 md:w-9rem pr-0">
                        <TextInputField name="BuyerPO No" labelText={displayLabel && "BuyerPO No"} value={sellerPOItem.bPOdocNo} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-5 lg:col-5 md:w-5rem pr-0">
                        <div className="flex flex-column">
                            <div className="flex flex-row align-items-center mb-1">
                                <label className="mr-1" style={{ fontSize: '12px' }}>{pmCompanyConfig.GSTRateLabel}</label>
                                {!sellerPOItem.isEditGSTRate ? <i style={{ fontSize: '0.8rem'}} onClick={(event) => props.handleClickEditInvGSTRateandHSN(event, groupingItemId, sellerPOItem.sellerPOItemId, sellerPOItem.sellerPOId, "invGSTRate")} className={`pi pi-file-edit cursor-pointer`}></i> : ""}
                            </div>
                            <div className="flex flex-column" style={{width: "100%" }}>
                                <DropDownField name="invGSTRate" labelText='' value={sellerPOItem?.invGSTRate} options={relatedGSTRates} optionLabel="label" optionValue="GSTRate" keyfilter="num" onChange={(event) => props.handleInvGSTandHSNChange(event, groupingItemId, sellerPOItem.sellerPOItemId, sellerPOItem.sellerPOId)} disabled={isQtyCannotBeChanged || sellerPOItem?.availableDispatchQuantity === 0 || !sellerPOItem.isEditGSTRate}  />
                            </div>
                        </div>
                    </div>
                    {
                        isHSNEntryAllowed ?
                            <div className="flex flex-column col-12 md:col-5 lg:col-5 md:w-6rem pr-0">
                                <div className="flex flex-row align-items-center mb-1">
                                    <label className="mr-1" style={{ fontSize: '12px' }}>HSNCode</label>
                                    {!sellerPOItem.isEditHSNCode ? <i style={{ fontSize: '0.8rem'}} onClick={(event) => props.handleClickEditInvGSTRateandHSN(event, groupingItemId, sellerPOItem.sellerPOItemId, sellerPOItem.sellerPOId, "invHSNCode")} className={`pi pi-file-edit cursor-pointer flex flex-row`}></i> : ""}
                                </div>
                                <div className="flex flex-column" style={{ width: "100%" }}>
                                    <TextInputField name="invHSNCode" labelText="" value={sellerPOItem?.invHSNCode} keyfilter={"pint"} onChange={(event) => props.handleInvGSTandHSNChange(event, groupingItemId, sellerPOItem.sellerPOItemId, sellerPOItem.sellerPOId)} disabled={isQtyCannotBeChanged || sellerPOItem?.availableDispatchQuantity === 0 || !sellerPOItem.isEditHSNCode} />
                                </div>
                            </div> : null
                    }
                    <div className="flex flex-column col-12 md:col-6 lg:col-6 md:w-6rem pr-0">
                        <TextInputField name="sellerPOQty" labelText={displayLabel && "SPO Qty"} value={sellerPOItem.qty} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-6 lg:col-6 md:w-6rem pr-0">
                        <TextInputField name="totalAcceptedQuantity" labelText={displayLabel && "TTL Acpt. Qty"} value={sellerPOItem.invoicedQty} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-6 lg:col-12 md:w-6rem pr-0">
                        <TextInputField name="totalDispatchQty" labelText={displayLabel && "TTL Disp. Qty"} value={round(sellerPOItem.stockDispatchQty, DECIMAL_LIMIT)} disabled /> {/* labelText={displayLabel && "TTL Dispatched Qty"} */}
                    </div>
                    <div className="flex flex-column col-12 md:col-6 lg:col-12 md:w-6rem pr-0">
                        <TextInputField name="totalConvertedQty" labelText={displayLabel && "TTL Conv. Qty"} value={round(sellerPOItem.totalConvertedQty, DECIMAL_LIMIT)} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-5 lg:col-5 md:w-6rem pr-0">
                        <TextInputField name="availableQty" labelText={displayLabel && "Available Qty"} value={sellerPOItem.availableDispatchQuantity} disabled /> {/*// round(sellerPOItem.totalAcceptedQuantity - sellerPOItem.totalDispatchQty,2) */}
                    </div>
                    <div className="flex flex-column col-12 md:col-7 lg:col-7 md:w-8rem pr-0">
                        <TextInputField name="dispatchQty" labelText={`${labelName} (${UOMStr})`} value={isQtyCannotBeChanged ? sellerPOItem.availableDispatchQuantity : sellerPOItem.dispatchQty} disabled={isQtyCannotBeChanged || sellerPOItem?.availableDispatchQuantity === 0} keyfilter="pnum" onChange={(event) => props.handleDispatchQtyChange(event, groupingItemId, sellerPOItem.sellerPOItemId, sellerPOItem.sellerPOId)} />
                    </div>
                    <div className="flex flex-column col-12 md:col-7 lg:col-7 md:w-7rem pr-0">
                        <TextInputField name="invoicedQty" labelText={displayLabel && `Inv Qty (${sellerPOItem.companyERPUOM})`} value={invoicingQty && `${invoicingQty}`} disabled keyfilter="pnum" /> {/* labelText={displayLabel && `Invoicing Qty (${sellerPOItem.companyERPUOM})`} */}
                    </div>
                    <div className="flex flex-column col-12 md:col-7 lg:col-4 pr-0">
                        <MultiSelectField name="sellerPIPunchItemId" labelText={displayLabel && "PI Punch"} options={sellerPOItem.sellerPIPunchDetails} optionLabel="sellerPINumber" optionValue="sellerPIPunchItemId" itemTemplate={piPunchItemTemplate} value={sellerPOItem.sellerPIPunchItemId} onChange={(event) => props.handleDispatchQtyChange(event, groupingItemId, sellerPOItem.sellerPOItemId, sellerPOItem.sellerPOId)} optionDisabled={(piPunch) => !isPIPunchAllowed(piPunch)} />
                    </div>
                </div>
                { sellerPOItem.GSTRate !== sellerPOItem.bPOGSTRate ? <div className='mb-2'><i style={{ fontSize: '11px' }} className="pi pi-info-circle custom-target-icon ml-1"><span className='ml-1' style={{color:"red"}}>Seller GSTRate was modified, please check and proceed</span></i> </div>: "" }
                <Tooltip target=".pi-punch-tooltip" showOnDisabled position="right" content="PI is not verified!" />
            </div>
        </div>
    )
}

export default DispatchSellerPOItems;